import { render, staticRenderFns } from "./SmokeRecord.vue?vue&type=template&id=0db68b8e&scoped=true"
import script from "./SmokeRecord.vue?vue&type=script&lang=js"
export * from "./SmokeRecord.vue?vue&type=script&lang=js"
import style0 from "./SmokeRecord.vue?vue&type=style&index=0&id=0db68b8e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0db68b8e",
  null
  
)

export default component.exports